import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import common_en from "./translations/en/translation.json";
import common_fr from "./translations/fr/translation.json";
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //   .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(Backend)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        common: common_en,
      },
      fr: {
        common: common_fr,
      },
    },
  });

export default i18n;

export const useLangue = ()=>{
  const [isFrancais, setIsFrancais] = useState(false);
  const [t, i18n] = useTranslation("common");

  useEffect(() => {
    setIsFrancais(i18n.language === "fr");
  }, [i18n.language]);
  return isFrancais;
}
